import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { FormControl, Validators } from '@angular/forms';
import { AppService } from '../../../services/app/app.service';

@Component({
    selector: 'kiene-new-password',
    templateUrl: './new-password.component.html',
    styleUrls: ['./new-password.component.scss'],
})
export class NewPasswordComponent implements OnInit {
    @Output('changePassword') changePassword = new EventEmitter<string>();

    showPassword = true;
    showPasswordRepeat = true;
    passwordCtrl = new FormControl(undefined, [Validators.minLength(8)]);
    passwordConfirmCtrl = new FormControl(undefined, [Validators.minLength(8)]);

    // Passwort-Validierungsstatus
    passwordValidation = {
        minLength: false,
        hasUppercase: false,
        hasLowercase: false,
        hasNumber: false,
        hasSpecialChar: false,
        passwordsMatch: false
    };

    constructor(private readonly appService: AppService) {}

    ngOnInit(): void {
        const pwd = this.appService.generateKienePassword();
        this.passwordCtrl.setValue(pwd);
        this.passwordConfirmCtrl.setValue(pwd);

        // Passwort-Validierung bei jeder Änderung aktualisieren
        this.passwordCtrl.valueChanges.subscribe(() => this.validatePassword());
        this.passwordConfirmCtrl.valueChanges.subscribe(() => this.validatePassword());

        // Initiale Validierung durchführen
        this.validatePassword();
    }

    validatePassword() {
        const password = this.passwordCtrl.value || '';
        const passwordRepeat = this.passwordConfirmCtrl.value || '';

        // Mindestlänge prüfen
        this.passwordValidation.minLength = password.length >= 8;

        // Großbuchstaben prüfen
        this.passwordValidation.hasUppercase = /[A-Z]/.test(password);

        // Kleinbuchstaben prüfen
        this.passwordValidation.hasLowercase = /[a-z]/.test(password);

        // Zahlen prüfen
        this.passwordValidation.hasNumber = /[0-9]/.test(password);

        // Sonderzeichen prüfen
        this.passwordValidation.hasSpecialChar = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(password);

        // Passwörter übereinstimmen (nur wenn beide ausgefüllt sind)
        this.passwordValidation.passwordsMatch = password.length > 0 && passwordRepeat.length > 0 && password === passwordRepeat;
    }

    isPasswordValid(): boolean {
        return (
            this.passwordValidation.minLength &&
            this.passwordValidation.hasUppercase &&
            this.passwordValidation.hasLowercase &&
            this.passwordValidation.hasNumber &&
            this.passwordValidation.passwordsMatch
        );
    }

    save() {
        this.changePassword.emit(this.passwordCtrl.value);
    }
}
